import { inject, Injectable } from "@angular/core";
import { CommonProcessTreeColumns, CommonProcessTreeQueryComplexInput, CommonProcessTreeSimpleQueryInput, CommonProcessTreeSortInput, ComparatorOperators, DownloadRiskMapTreeRiskViewGQL, DownloadRiskMapTreeRiskViewMutation, GetCptFiltersGQL, GetCptFiltersQuery, GetRiskMapRiskGQL, GetRiskMapRiskQuery, OperatorInput, OrderTypeInput, PagingInput, UpdateRiskMapRiskGQL, UpdateRiskMapRiskMutation } from "../../../graphql/generated";
import { map, Observable } from "rxjs";
import { MutationData, unwrapMutationData } from "../shared/graphql-mutation-response.util";

@Injectable({
    providedIn: 'root'
})

export class RiskmapRiskService {
    private readonly GetRiskMapRiskGQL: GetRiskMapRiskGQL = inject(GetRiskMapRiskGQL);
    private readonly GetCptFiltersGQL: GetCptFiltersGQL = inject(GetCptFiltersGQL);
    private readonly UpdateRiskMapRiskGQL: UpdateRiskMapRiskGQL = inject(UpdateRiskMapRiskGQL)
    private readonly DownloadRiskMapTreeRiskViewGQL: DownloadRiskMapTreeRiskViewGQL = inject(DownloadRiskMapTreeRiskViewGQL);

    getRiskmapRisk(campaignId: string, riskId: string, valueChain: string, parameters: any, legalEntitiesId: string[]): Observable<GetRiskMapRiskQuery['riskViewByCampaignIdAndRiskId']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.GetRiskMapRiskGQL.fetch({ campaignId, riskId, valueChain, query: param.query, sort: param.sort, page: param.page, legalEntitiesId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.riskViewByCampaignIdAndRiskId))
    }

    getRiskmapRiskFilters(valueChain: string): Observable<GetCptFiltersQuery['commonProcessTreeFields']> {
        return this.GetCptFiltersGQL.fetch({ active: null, ids: [], valueChain }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.commonProcessTreeFields))
    }

    updateRiskmapRisk(campaignId: string, legalEntityId: string, processId: string, riskId: string, riskMapId: string, value: boolean, legalEntitiesId: string[], filters: boolean): Observable<MutationData<UpdateRiskMapRiskMutation['updateValueRiskView']>> {
        return this.UpdateRiskMapRiskGQL.mutate({ campaignId, legalEntityId, processId, riskId, riskMapId, value, legalEntitiesId, filters }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.updateValueRiskView), unwrapMutationData('Unable to update the risk map'))
    }
    downloadRiskRiskmap(
        campaignId: string,
        riskId: any,
        parameters: any,
        timeZone: string,
        valueChain: string,
        legalEntitiesId: string[]
    ): Observable<DownloadRiskMapTreeRiskViewMutation['downloadRiskMapTreeRiskView']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.DownloadRiskMapTreeRiskViewGQL.mutate({ campaignId, riskId, timeZone, valueChain, query: param.query as CommonProcessTreeQueryComplexInput, sort: param.sort as CommonProcessTreeSortInput, legalEntitiesId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.downloadRiskMapTreeRiskView))
    }
}

export function convertLazyLoadToComplexWithoutPage(parameters: any): { query: CommonProcessTreeQueryComplexInput, sort: CommonProcessTreeSortInput, page: PagingInput } {
    const query: CommonProcessTreeSimpleQueryInput[] = [];

    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_PROCESS_RISKMAP[field as keyof typeof ENUM_PROCESS_RISKMAP]).forEach(key => {

                        let filteredValue: any[] = [];
                        filteredValue = values
                        query.push({
                            field: key as CommonProcessTreeColumns,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: filteredValue
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query: query,
                    operator: OperatorInput.And
                }
            ]
        },
        sort: {
            sortField: ENUM_PROCESS_RISKMAP?.[parameters?.order?.sortField as keyof typeof ENUM_PROCESS_RISKMAP]?.[0] as CommonProcessTreeColumns || CommonProcessTreeColumns.Sort,
            sortOrder: parameters?.order?.sortDirection === 'ASC' ? OrderTypeInput.Asc : OrderTypeInput.Desc
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 1
        }
    }
}


export const ENUM_PROCESS_RISKMAP = {
    name: [CommonProcessTreeColumns.Name],
    code: [CommonProcessTreeColumns.Code],
    cluster: [CommonProcessTreeColumns.Cluster]
}